import { createSlice } from '@reduxjs/toolkit';

const initialStateAgencyList = {
    listLoading: false,
    actionsLoading: false,
    pAgencyList: undefined,
    agencyDetail: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const pAgencyListSlice = createSlice({
    name: "pAgencyList",
    initialState: initialStateAgencyList,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List agency
        agencyListFetched: (state, action) => {
            state.listLoading = false;
            state.pAgencyList = action.payload.pAgencyList;
            state.error = null;
        },
        // get agency detail
        agencyDetailFetched: (state, action) => {
            state.listLoading = false;
            state.agencyDetail = action.payload.agencyDetail;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.agencyDetail = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pAgencyList = undefined;
            state.agencyDetail = undefined;
            state.error = null;
            state.success = null;
        }
    }
});